export const en = {
  menu: {
    main: "Main",
    sneakers: "Sneakers",
    cart: "Cart",
  },

  sneakersSection: {
    headerTitle: "SHOP ALL SNEAKERS",
    headerSubTitle:
      "Shop for new releases from must-have names like Air Jordan, Nike, New Balance and Yeezy, along with the latest collaborations from brands like Vans, Reebok, Converse, ASICS, and more.",
    filterSneakers: {
      filterTitle: "Filter",
      model: "Model",
      sizes: "Sizes",
      brand: "Brand",
      price: "Price",
      year: "Year",
    },
    apply: "apply",
    from: "from",
    to: "to",
    filterErrors: {
      yearBiggerLower: "'From' year should be lower than 'To' year",
      yearBigger: "Year can't be bigger than 2023",
      yearLower: "Year can't be lower than 1994",
      priceBiggerLower: "'From' price should be lower than 'To' price",
      priceBigger: "Price can't be bigger than 6000",
      priceLower: "Price can't be lower than 10",
    },
    sneakersResult: {
      resultsTitle: "Results",
      show: "Show",
      sort: {
        sotrBy: "Sort By:",
        relevance: "Relevance",
        low: "Low",
        high: "High",
        newest: "Newest",
        trending: "Trending",
      },
      emptyText: {
        notFound: "Sorry, no results found",
        checkFilters: "Please check your filters or search for another sneaker",
      },
    },
  },

  mainSection: {
    shopNow: "shopNow",
    newReleases: {
      title: "NEW RELEASES",
      button: "Shop New releases",
    },
    staffPicks: {
      title: "STAFF PICKS",
      button: "Shop Staff Picks",
    },
    about: {
      titleStore: "SNEAKER SHOP STORES",
      titleHistory: "OUR HISTORY",
      textStore:
        "With three retail locations in New York, Los Angeles, and Miami, Flight Club remains the premier source for everything sneakers.",
      textHistory:
        "For over a decade, Flight Club has changed the landscape of sneaker retail. Carrying every brand name on the market, Flight Club has evolved from a one-stop sneaker destination, to a cultural hub for sneaker enthusiasts and novices alike. From Air Jordans to Nike to Adidas and more, we have it all.",
    },
  },

  cartSection: {
    title: "YOUR SHOPPING CART",
    total: "ORDER TOTAL",
    buttonOrder: "Place order",
    size: "Size",
    emptyCart: "Cart is empty",
  },

  favoriteSection: {
    title: "Favorite sneakers",
    emptyFavorites: "You haven't added favorite sneakers yet",
  },

  sneakerPage: {
    size: "select size",
    buy: "Buy for",
    goToCart: "Go to cart",
    addedToCart: "Item is added to cart",
    delivery: {
      title: "Shipping & Returns",
      cancelations: "Cancelations",
      cancelationsDescription1:
        "For sneakers, you may cancel your order within 3 hours of placing it or before it is confirmed by the seller - whichever comes first. If 3 hours have passed from when you placed the order and/or the seller has already confirmed the order, then the order cannot be canceled. If neither have occurred, you can cancel your order first by accessing it via “Track My Order” or “My Account,” clicking “Cancel Order” and following the instructions.",
      cancelationsDescription2:
        "If you checked out as a guest, you will need to create a Flight Club account.",
      delivery: "Delivery",
      deliveryDescription1:
        "Delivery and processing speeds vary by pricing options. The following shipping estimates apply only to the contiguous US and exclude deliveries to PO boxes and military bases. All delivery times are estimates and are not guaranteed. Shipments may be affected by weather-related delays, carrier limitations or other events outside of our control.",
      deliveryDescription2:
        "'Lowest Price' orders may ship to Flight Club first for verification and typically take 7-10 business days (M-F, excluding holidays) to reach you. It will typically take 3-5 business days (M-F, excluding holidays) for a 'Fastest To You' item, ordered before 2 PM ET with standard shipping, to be delivered.",
      deliveryDescription3:
        "Estimated delivery times do not apply to international orders. International customers are responsible for any additional fees or taxes after an item ships.",
      returns: "Returns",
      returnsDescription1: "All sales with Flight Club are final.",
      returnsDescription2:
        "If you have any questions or concerns with regard to sizing or condition of a specific product on our site, please contact us before purchasing.",
    },
    recommended: "RECOMMENDED FOR YOU",
  },

  placeOrderSection: {
    orderConfirmed: {
      title: "Order confirmed",
      hint: "wait for our manager's response by e-mail",
      button: "Back to Main",
    },
    title: "SHIPPING INFORMATION",
    email: "Your Email Address",
    name: "Full Name",
    address: "Street Address",
    city: "City",
    zip: "Zip / Postal Code",
    telephone: "Telephone",
    emailPlaceholrer: "email",
    namePlaceholrer: "name",
    addressPlaceholrer: "address",
    cityPlaceholrer: "city",
    zipPlaceholrer: "zip",
    telephonePlaceholrer: "telephone",
    makeOrderBTN: "Make order",
  },

  inputErrors: {
    enterEmail: "enter email address",
    incorrect: "incorrect email address",
    enterFullName: "enter your full name",
    enterFirstAndLastName: "enter first and last name",
    enterAddress: "enter your address",
    enterCity: "enter your city",
    enterZip: "enter zip code",
    incorrectZip: "incorrect zip code",
    wrongNumberDigits: "wrong number of digits",
    incorrectTelephone: "incorrect telephone number",
  },
};
